export default {
  winSale: 'Relaxed',
  angryClient: 'Angry',
  neutralClient: 'Neutral',
  mixedClient: 'Mixed',
  suggestionAnswers: 'Suggestion answers',
  support1: 'Oh! I\'m so sorry, I\'ll help you with that',
  support2: 'Doesn\'t usually happen, we\'ll give you a refund',
  noEmail: 'umm the e-mail is missing, get it!',
  devices: 'Devices',
  noDevices: 'No devices yet',
  waitingForReply: 'Waiting for reply',
  noAdvices: 'Not advices yet',
  advices: 'Advices',
  noExtradata: 'No extradata yet',
  noOpportunities: 'No opportunities yet',
  noSegments: 'No segments yet',
  noRoles: 'No roles yet',
  noResponsible: 'No owner yet',
  noNotes: 'No nots yet',
  seemsOpportunity: 'This seems to be a sales opportunity',
  seemsEmail: 'Seems that we have an email here!',
  letPass: 'Let it pass',
  greetings1: ' hi,😝 thanks for you message',
  greetings2: ' Whats up! Good to chat you!',
  employmentHistory: 'Employment history',
  pleaseGiveMeYourEmail: 'Give me your email to keep in touch',
  emailMissingGeIt: 'umm the e-mail is missing, get it!',
  toggleSound: 'Toggle sound',
  seemsBloodType: 'This seems to be the blood type',
  seemsHeight: 'This seems to be the height',
  dataMissingGetIt: 'Data missing, get it!',
  requestBloodType: 'Can you give me your blood type?',
  requestHeight: 'Can you give me your height?',
  requestWeight: 'Can you give me your weight?',
  requestAllergies: 'Are you allergic to anything?',
  notEnoughData: 'Not enough data',
  'Blood type': 'Blood type',
  Height: 'Height',
  Weight: 'Weight',
  Allergies: 'Allergies',
  IMC: 'IMC',
  seemsWeight: 'This seems to be the weight',
  seemsAllergies: 'This seems to be the allergies',
  'imc-underweight': 'Underweight',
  'imc-normal': 'Normal',
  'imc-overweight': 'Overweight',
  'imc-obesity': 'Obesity',
  'imc-severe-obesity': 'Severe obesity',
  'imc-morbidity-obesity': 'Morbidity obesity',
  seemsId: 'This seems to be an id number',
  seemsPhone: 'This seems to be a phone number',
  seemsTicket: 'Looks like someone needs help'
}
